<template>
  <div
    v-if="errorMessage"
    class="alert alert-danger alert-dismissible fade show mb-4"
    role="alert"
  >
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <div class="font-weight-bold mb-2">
          {{ errorTitle }}
        </div>        
        <div
          class="error-details"
        >
          {{ errorDetails }}
        </div>
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        @click="$emit('clear')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  errorMessage: string | null;
  errorTitle: string;
  errorDetails: string;
}>();

defineEmits<{
  clear: [];
}>();
</script>

<style scoped>
.error-details {
  margin-top: 0.5rem;
}
</style>
